import * as qs from "query-string";
import history from "@safecv/shared/history";

export const handleURLChange = (obj) => {
  try {
    let urlSearch = qs.parse(window.location.search);
    const objKeys = Object.keys(obj);
    if (objKeys.length > 0) {
      for (let key of objKeys) {
        if (obj[key] !== undefined && obj[key] !== "") {
          urlSearch[key] = obj[key];
        }
        if (obj[key] === "") delete urlSearch[key];
      }
    }
    const urlStr = qs.stringify(urlSearch);
    history.replace({
      search: urlStr,
    });
  } catch (e) {
    console.error(e);
  }
};

export const handleURLUpdate = (jobId, type) => {
  let url = window.location.search;
  history.replace("/plan/" + jobId + "/" + type + url);
};
